import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=24e1f149"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports